import React, {useEffect, useState} from 'react';
import { 
    isLessThanAnHour, 
    isSpectator, 
    isLiveInProgress, 
    isLiveInHalfTime, 
    getChronoFromLiveDebut, 
    getSecondChrono, 
    isRegularTimeEnd, 
    isLiveEnded, 
    isOvertimeEnd, 
    isTabStarted } from '../../../../helpers';
import _ from 'lodash';
import Chrono from '../../../Chrono';
import './Status.css';
import PropTypes from 'prop-types';

const Status = ({match, live, pageReducer}) => {
    const [minute, setMinute] = useState(0);
    const [second, setSecond] = useState(0)
    
    useEffect(() => {

        const interval = setInterval(() => {
            const minute = getChronoFromLiveDebut(live.actions)
            const second = getSecondChrono(live.actions);
            setMinute(minute)
            setSecond(second);
        }, 1000)

        return () => clearInterval(interval);
    });

    return getStatus(live, match, pageReducer, minute, second)
}

const getStatus = (live, match, pageReducer, minute, second) => {
    if(!_.isEmpty(live) && !_.isEmpty(match)) {
        if(isLiveEnded(live) || pageReducer === 'pastMatch') {
            return <span className='status'>le match est terminé</span>
        }
        else if(!isLessThanAnHour(match.date) && !isSpectator([live])) {
            const text = isSpectator([live]) ? 'Le live sera disponible 1h avant le match' : 'Ton live sera disponible 1h avant le match'
            return <span className='status'>{text}</span>
        }   
        else if(isLessThanAnHour(match.date) && live.actions.length === 0 && !isSpectator([live])) {
            return <span className='status'>LE LIVE VA COMMENCER</span>
        }
        else if(isLiveInHalfTime(live.actions)) {
            return <span className='status'>mi-temps</span>
        }
        else if(isRegularTimeEnd(live.actions)) {
            return <span className='status'>fin du temps réglementaire</span>
        }
        else if(isOvertimeEnd(live.actions)) {
            return <span className='status'>fin de la prolongation</span>
        }
        else if(isTabStarted(live.actions)) {
            return <span className='status'>fin du temps réglementaire</span>
        }
        else if(isLiveInProgress(live)){
            const minuteLocal = getChronoFromLiveDebut(live.actions)
            const secondLocal = getSecondChrono(live.actions);
            const text = _.toNumber(minute) < 0 ? 'Le match est terminé' : <Chrono startedMin={minuteLocal} startedSec={secondLocal} mainMinute={minute} mainSecond={second} />
            return <span className='status'>{text}</span>
        }
        else {
            return '';
        }
    }
    else {
        return '';
    }
}

Status.propTypes = {
    live: PropTypes.shape({
        ended: PropTypes.bool,
        actions: PropTypes.array
    }),
    match: PropTypes.shape({
        date: PropTypes.string
    }),
    pageReducer: PropTypes.string.isRequired
}

export default Status;